import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { sectionSettingsConstants, useDeleteSection, useSectionSettings } from '..';

export function useTransferToDepartment() {
  const qc = useQueryClient();
  const {
    trash: { id, departmentId, employees },
    methods: { setTrash }
  } = useSectionSettings();
  const { mutateAsync } = useDeleteSection();
  const [{ page = 1, search }] = useQueryParams({
    page: NumberParam,
    search: StringParam
  });

  return useMutation(
    async () => {
      const { data } = await $api.put('/v1/employee/transfer-to-department', {
        departmentId,
        employeeIds: employees?.map(({ id }) => id)
      });

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async () => {
        await mutateAsync(id);
        await qc.invalidateQueries([sectionSettingsConstants.queryKeys.DEPARTMENTS, page, search]);

        setTrash({
          departmentId: undefined,
          employees: [],
          visible: false,
          id: undefined
        });
      }
    }
  );
}
